import { Button, Checkbox, Form, Input, message } from "antd";
import { signInWithPopup } from "firebase/auth";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { addToMailchimp, socialLogin, userSignUp } from "../../../../controller/services/auth";
import { auth, provider } from "../../../../firebase";
import useFormValidation from "../../../../hooks/useFormValid";
import i18n from "../../../../localization/i18n";
import {
  setInfoContent,
  setLoading,
  setStepperStatus,
} from "../../../../redux/slices/common_slice";
import { setUserData } from "../../../../redux/slices/user_slice";
import { routePaths } from "../../../../routing/routePaths";
import LoginSignupWrapper from "../LoginSignupWrapper";
import { getApiErrorMessage } from "../../../../utils/helper";
import axios from "axios";

const FB_APP_ID = process.env.REACT_APP_FB_APP_ID || "1204776367620016";

const SignUp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [checkVal, setCheckChange] = useState(false);
  const [checkNewsVal, setCheckNewsChange] = useState(false);
  const { handleValuesChange, formValues, setFormValues } =
    useFormValidation(form);

  console.log(formValues, "formValues");
  const credentials = JSON.parse(localStorage.getItem("credentials"));
  const fcmToken = Cookies.get("fcmToken");
  const [fbAuthType, setFbAuthType] = useState();
  useEffect(() => {
    localStorage.setItem(
      "credentials",
      JSON.stringify({
        username: formValues.username,
        password: formValues.password,
      })
    );
  }, [formValues.username, formValues.password]);

  useEffect(() => {
    const username = formValues?.username || credentials?.username;
    const password = formValues?.password || credentials?.password;
    form.setFieldValue("username", username);
    form.setFieldValue("password", credentials?.password);
    setFormValues({
      username: username,
      password: password,
    });
  }, []);
  const onFinish = (values) => {
    dispatch(setLoading(true));
    const payload = {
      email: values.username?.toLowerCase(),
      password: values.password,
      fullName: values.fullName,
      loginType: "email", //email || facebook || google
      fcmToken: fcmToken,
      isNewsLetterChecked: checkNewsVal,
    };
    const hubSpotPayload = {
      fields: [
        { name: "email", value: values?.username?.toLowerCase() },
        {
          name: "firstname",
          value: values?.fullName || values?.username?.split("@")?.[0],
        },
      ],
    };
    const mailChimpPayload = {
      email: values.username?.toLowerCase(),
      firstName: values.fullName,
      lastName: " "
    }
    userSignUp(payload)
      .then(async (resp) => {
        if (checkNewsVal) {
          await axios.post(
            "https://api.hsforms.com/submissions/v3/integration/submit/2686942/9623fd3b-2ca2-4597-8100-833b1e055907",
            hubSpotPayload,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          await addToMailchimp(mailChimpPayload)
        }
        message.success(resp?.message[i18n.language]);
      })
      .catch((Err) => {
        message.error(Err.message[i18n.language]);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  const signInWithGoogle = () => {
    dispatch(setLoading(true));
    dispatch(
      setStepperStatus({
        isExpenseCompletion: false,
        isProfileCompletion: false,
        isIncomeCompletion: false,
        step: 0,
      })
    );
    signInWithPopup(auth, provider)
      .then((resp) => {
        dispatch(setLoading(true));
        const email = resp?.user?.email?.trim().toLowerCase();
        const googleId = resp?.user?.uid;
        if (!email || !googleId) {
          message.error(t("errors.socialLoginFailed"));
          dispatch(setLoading(false));
          return;
        }
        const payload = {
          loginType: "google",
          email: email,
          googleId: googleId,
        };
        if (resp?.user?.displayName) {
          payload.fullName = resp.user.displayName;
        }
        if (fcmToken) {
          payload.fcmToken = fcmToken;
        }
        socialLogin(payload)
          .then((respo) => {
            localStorage.setItem("token", respo.data.token);
            localStorage.removeItem("credentials");
            dispatch(setUserData(respo.data?.socialUserData));
            dispatch(setStepperStatus(respo.data.status));
            message.success(respo?.message?.[i18n.language]);
            navigate(routePaths?.getStarted);
          })
          .catch((err) => {
            message.error(
              getApiErrorMessage(err, t("errors.socialLoginFailed"))
            );
          })
          .finally(() => {
            dispatch(setLoading(false));
          });
      })
      .catch((err) => {
        dispatch(setLoading(false));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  const signinWithFb = ({ email, facebookId, fullName }) => {
    dispatch(setLoading(true));
    dispatch(
      setStepperStatus({
        isExpenseCompletion: false,
        isProfileCompletion: false,
        isIncomeCompletion: false,
        step: 0,
      })
    );
    const payload = {
      loginType: "facebook",
      email: email,
      facebookId: facebookId,
    };
    if (fullName) {
      payload.fullName = fullName;
    }
    if (fcmToken) {
      payload.fcmToken = fcmToken;
    }
    socialLogin(payload)
      .then((respo) => {
        localStorage.setItem("token", respo.data.token);
        localStorage.removeItem("credentials");
        dispatch(setUserData(respo.data?.socialUserData));
        dispatch(setStepperStatus(respo.data.status));
        message.success(respo?.message?.[i18n.language]);
        navigate(routePaths?.getStarted);
      })
      .catch((err) => {
        message.error(getApiErrorMessage(err, t("errors.socialLoginFailed")));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  const responseFacebook = (response) => {
    if (response?.status === "unknown" || !response?.id) {
      dispatch(setInfoContent(t("errors.fbLogin")));
      return;
    }
    const email = response?.email?.trim().toLowerCase();
    if (!email) {
      // Facebook omits email for phone-only accounts or when the user
      // declined the email permission; the API requires it, so don't call.
      if (fbAuthType === "rerequest") {
        dispatch(setInfoContent(t("errors.fbNoEmail")));
      } else {
        setFbAuthType("rerequest");
        dispatch(setInfoContent(t("errors.fbEmailPermission")));
      }
      return;
    }
    signinWithFb({
      email: email,
      facebookId: response.id,
      fullName: response?.name,
    });
  };

  // react-facebook-login@4.1.1 has no authType prop, so a second click would
  // not re-prompt for the declined email permission; call FB.login with
  // auth_type=rerequest ourselves (still inside the user's click gesture).
  const handleFbEmailRerequest = (renderProps) => {
    if (!window.FB) {
      renderProps?.onClick?.();
      return;
    }
    window.FB.login(
      (resp) => {
        if (resp?.authResponse) {
          window.FB.api("/me", { fields: "name,email" }, (me) =>
            responseFacebook({ id: resp.authResponse.userID, ...me })
          );
        } else {
          dispatch(setInfoContent(t("errors.fbLogin")));
        }
      },
      {
        scope: "public_profile,email",
        auth_type: "rerequest",
        return_scopes: true,
      }
    );
  };
  return (
    <LoginSignupWrapper>
      <div className="row auth-details-inner-row">
        <div className="col-12 auth-details-col-9-p">
          <a href="#">
            <img
              src="/assets/images/butterfly-logo.svg"
              alt=""
              className="img-fluid logo-auth"
            />
          </a>
          <h6>{t("welcome")}</h6>
          <h1 className="mb-2">{t("welcomeInfo")}</h1>
          <h6 className="descripation">{t("signupDesc")}</h6>
          <Form
            className="common-form"
            initialValues={{
              username: "",
              password: "",
            }}
            onFinish={onFinish}
            name="signup-form"
            form={form}
            autoComplete="off"
            onValuesChange={handleValuesChange}
          >
            <Form.Item
              label={false}
              name="fullName"
              rules={[
                {
                  required: true,
                  message: t("errors.name"),
                },
                {
                  pattern: /^[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/,
                  message: t("errors.validName"),
                },
              ]}
            >
              <Input
                prefix={
                  <img
                    alt=""
                    className="img-fluid"
                    src={
                      formValues.fullName
                        ? "/assets/images/icons/user-icon-primary.svg"
                        : "/assets/images/icons/user-icon.svg"
                    }
                  />
                }
                placeholder={t("aboutYou.step1.ques1.placeholder")}
              />
            </Form.Item>
            <Form.Item
              shouldUpdate
              label={false}
              name="username"
              rules={[
                {
                  required: true,
                  message: t("errors.email"),
                },
                {
                  pattern:
                    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                  message: t("errors.validEmail"),
                },
              ]}
            >
              <Input
                prefix={
                  <img
                    alt=""
                    className="img-fluid"
                    src={
                      formValues?.username
                        ? "/assets/images/icons/message-icon-primary.svg"
                        : "/assets/images/icons/message-icon.svg"
                    }
                  />
                }
                placeholder={t("enterEmail")}
              />
            </Form.Item>
            <Form.Item
              label={false}
              name="password"
              rules={[
                {
                  required: true,
                  message: t("errors.password"),
                },
                {
                  pattern:
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-={}\[\]:;"'<>,./?|\\])[A-Za-z\d!@#$%^&*()_+\-={}\[\]:;"'<>,./?|\\]{8,}$/,
                  message: t("errors.validPass"),
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (value.length <= 50) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(t("errors.maxLimit")));
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={
                  <img
                    alt=""
                    className="img-fluid"
                    src={
                      formValues?.password
                        ? "/assets/images/icons/lock-icon-primary.svg"
                        : "/assets/images/icons/lock-icon.svg"
                    }
                  />
                }
                iconRender={(visible) =>
                  visible ? (
                    <img
                      alt=""
                      className="img-fluid"
                      src="/assets/images/icons/eye-icon-primary.svg"
                    />
                  ) : (
                    <img
                      alt=""
                      className="img-fluid"
                      src="/assets/images/icons/hide-eye-icon.svg"
                    />
                  )
                }
                placeholder={t("enterPassword")}
              />
            </Form.Item>

            <Form.Item
              label={false}
              name="enterConfirmPassword"
              rules={[
                {
                  required: true,
                  message: t("errors.password"),
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (value && formValues?.password != value) {
                      return Promise.reject(new Error(t("errors.confirmPass")));
                    } else if (value.length <= 50) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(t("errors.maxLimit")));
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={
                  <img
                    alt=""
                    className="img-fluid"
                    src={
                      formValues?.enterConfirmPassword
                        ? "/assets/images/icons/lock-icon-primary.svg"
                        : "/assets/images/icons/lock-icon.svg"
                    }
                  />
                }
                iconRender={(visible) =>
                  visible ? (
                    <img
                      alt=""
                      className="img-fluid"
                      src="/assets/images/icons/eye-icon-primary.svg"
                    />
                  ) : (
                    <img
                      alt=""
                      className="img-fluid"
                      src="/assets/images/icons/hide-eye-icon.svg"
                    />
                  )
                }
                placeholder={t("enterConfirmPassword")}
              />
            </Form.Item>
            <Form.Item>
              <Checkbox
                checked={checkVal}
                onChange={(e) => setCheckChange(e.target.checked)}
              >
                <Trans
                  i18nKey="acceptTerms"
                  components={{
                    linkTerms: (
                      <Link to={routePaths.termsAndConditions}>
                        <b></b>
                      </Link>
                    ),
                    linkPrivacy: (
                      <Link to={routePaths.privacyPolicy}>
                        <b></b>
                      </Link>
                    ),
                  }}
                />
              </Checkbox>
              <Checkbox
                checked={checkNewsVal}
                onChange={(e) => setCheckNewsChange(e.target.checked)}
              >
                {" "}
                {t("newsLetter")}
              </Checkbox>
            </Form.Item>

            <Form.Item>
              <Button
                className="auth-theme-btn auth-login-btn"
                type="primary"
                htmlType="submit"
                disabled={
                  !formValues?.username ||
                  !formValues?.password ||
                  !formValues?.enterConfirmPassword ||
                  !formValues?.fullName ||
                  !checkVal ||
                  form.getFieldError("username")?.length > 0 ||
                  form.getFieldError("password")?.length > 0 ||
                  form.getFieldError("fullName")?.length > 0
                }
              >
                {t("signup")}
              </Button>
            </Form.Item>
            <div className="row bottom-details-login">
              <div className="col-12">
                <h6>
                  <span>{t("orSignupWith")}</span>
                </h6>
                <ul className="list-inline">
                  <li className="list-inline-item">
                    <Button className="google-fb-login-btn">
                      <FacebookLogin
                        appId={FB_APP_ID}
                        fields="name,email,picture"
                        scope="public_profile,email"
                        callback={responseFacebook}
                        render={(renderProps) => (
                          <img
                            alt="facebook icon"
                            className="img-fluid"
                            onClick={
                              fbAuthType === "rerequest"
                                ? () => handleFbEmailRerequest(renderProps)
                                : renderProps?.onClick
                            }
                            src="/assets/images/icons/facebook-logo.svg"
                          />
                        )}
                        disableMobileRedirect={true}
                      />
                    </Button>
                  </li>
                  <li className="list-inline-item">
                    <Button
                      className="google-fb-login-btn"
                      onClick={signInWithGoogle}
                    >
                      <img
                        alt="google icon"
                        className="img-fluid"
                        src="/assets/images/icons/google-logo.svg"
                      />
                    </Button>
                  </li>
                </ul>
                <p>
                  {t("haveAccount")}{" "}
                  <Link to={routePaths.login}>{t("signin")}</Link>
                </p>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </LoginSignupWrapper>
  );
};

export default SignUp;
